var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15002 2.46001H17.85C18.75 2.46001 19.48 3.19001 19.48 4.09001V20.22C19.48 21.12 18.75 21.85 17.85 21.85H6.15002C5.25002 21.85 4.52002 21.12 4.52002 20.22V4.08001C4.52002 3.18001 5.25002 2.45001 6.15002 2.45001V2.46001Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74997 2H14.26C14.4138 2 14.54 2.12614 14.54 2.28V3.62C14.54 3.77386 14.4138 3.9 14.26 3.9H9.74997C9.59611 3.9 9.46997 3.77386 9.46997 3.62V2.28C9.46997 2.12614 9.59611 2 9.74997 2Z",
    fill: "white",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 9.77C9.73631 9.77 10.09 9.41631 10.09 8.98C10.09 8.5437 9.73631 8.19 9.30001 8.19C8.8637 8.19 8.51001 8.5437 8.51001 8.98C8.51001 9.41631 8.8637 9.77 9.30001 9.77Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 9.47998H11.26C10.98 9.47998 10.76 9.25998 10.76 8.97998C10.76 8.69998 10.98 8.47998 11.26 8.47998H15.49C15.77 8.47998 15.99 8.69998 15.99 8.97998C15.99 9.25998 15.77 9.47998 15.49 9.47998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 12.94C9.73631 12.94 10.09 12.5863 10.09 12.15C10.09 11.7137 9.73631 11.36 9.30001 11.36C8.8637 11.36 8.51001 11.7137 8.51001 12.15C8.51001 12.5863 8.8637 12.94 9.30001 12.94Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 12.65H11.26C10.98 12.65 10.76 12.43 10.76 12.15C10.76 11.87 10.98 11.65 11.26 11.65H15.49C15.77 11.65 15.99 11.87 15.99 12.15C15.99 12.43 15.77 12.65 15.49 12.65Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 16.11C9.73631 16.11 10.09 15.7563 10.09 15.32C10.09 14.8837 9.73631 14.53 9.30001 14.53C8.8637 14.53 8.51001 14.8837 8.51001 15.32C8.51001 15.7563 8.8637 16.11 9.30001 16.11Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 15.82H11.26C10.98 15.82 10.76 15.6 10.76 15.32C10.76 15.04 10.98 14.82 11.26 14.82H15.49C15.77 14.82 15.99 15.04 15.99 15.32C15.99 15.6 15.77 15.82 15.49 15.82Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.b555f08f.svg";
export { ForwardRef as ReactComponent };